import { render, staticRenderFns } from "./AssumeProgramRole.vue?vue&type=template&id=1d79bef3"
import script from "./AssumeProgramRole.vue?vue&type=script&lang=js"
export * from "./AssumeProgramRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports